import { render, staticRenderFns } from "./Complex.vue?vue&type=template&id=c459b388"
import script from "./Complex.vue?vue&type=script&lang=js"
export * from "./Complex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports